export interface ReplyContext {
  repliedMessageFrom?: string;
  repliedMessageFromSubtitle?: string;
  repliedMessage: string;
}

const REPLY_TAG_START = '<reply>';
const REPLY_TAG_END = '</reply>';

/**
 * Adds reply context to a message string for storage.
 */
export const addReplyContext = (reply: ReplyContext, messageText: string): string => {
  const encoded = JSON.stringify(reply).replace(/</g, '&lt;').replace(/>/g, '&gt;'); // avoid HTML injection issues

  return `${REPLY_TAG_START}${encoded}${REPLY_TAG_END}${messageText}`;
};

/**
 * Parses message string to extract reply context and message text.
 */
export const parseReplyContext = (messageWithContext: string): { reply?: ReplyContext; text: string } => {
  const start = messageWithContext.indexOf(REPLY_TAG_START);
  const end = messageWithContext.indexOf(REPLY_TAG_END);

  if (start === -1 || end === -1) {
    // No context found
    return { text: messageWithContext };
  }

  const encoded = messageWithContext.slice(start + REPLY_TAG_START.length, end);

  let reply: ReplyContext | undefined;
  try {
    const decoded = encoded.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    reply = JSON.parse(decoded);
  } catch {
    reply = undefined;
  }

  const text = messageWithContext.slice(end + REPLY_TAG_END.length).trim();

  return { reply, text };
};
